
jQuery(document).ready(function ($) {
    $('a.is-style-menu-cat-link.wp-block-tiptip-hyperlink-group-block').on('click', function (e) {        
        localStorage.setItem('readOnlyCategoryMenuItemCarryOver', $(this).attr('title'));

    });
    
});
